import styled, { css } from "styled-components";

/* Paleta existentă în proiect (conform fragmentelor tale) */
const paper = "#fffdfa";
const ink = "#1e1b16";
const gold = "#c4a453";
const shadow = "rgba(0,0,0,0.20)";
const shadowDeep = "rgba(0,0,0,0.35)";

export const Wrap = styled.section`
  width: 100%;
  display: grid;
  place-items: center;
  padding: 30px 10px 30px 10px;
`;

export const Card = styled.article`
  width: min(960px, 94vw);
  background: ${paper};
  color: ${ink};
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 16px;
  box-shadow: 0 8px 24px ${shadow}, 0 2px 6px ${shadowDeep};
  padding: 20px 18px;
  position: relative;

  @media (min-width: 720px) {
    padding: 26px 28px;
    border-radius: 18px;
  }
`;

export const TitleRow = styled.header`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
`;

export const Title = styled.h3`
  margin: 0;
  font-size: clamp(18px, 2.2vw, 24px);
  font-weight: 800;
  letter-spacing: 0.2px;
  color: ${ink};
`;

export const Badge = styled.span`
  padding: 6px 10px;
  border-radius: 999px;
  border: 1px solid ${gold};
  color: ${ink};
  font-size: 12px;
  letter-spacing: 0.3px;
  background: radial-gradient(
      120% 120% at 0% 0%,
      rgba(196, 164, 83, 0.15),
      transparent 60%
    ),
    #fff;
`;

export const Divider = styled.div`
  --gold: ${gold};
  margin: ${(p) => (p.soft ? "14px 0 18px" : "16px 0 20px")};
  height: 18px;
  position: relative;

  &::before,
  &::after {
    content: "";
    position: absolute;
    inset: 50% auto auto 0;
    height: 1px;
    width: 100%;
    transform: translateY(-50%);
    background: linear-gradient(
        90deg,
        transparent,
        var(--gold) 12%,
        transparent 24%
      ),
      linear-gradient(90deg, transparent 70%, rgba(0, 0, 0, 0.06));
  }

  /* mic ornament central (fleur-de-lis stilizat) */
  &::after {
    content: "";
    position: absolute;
    left: 50%;
    top: 50%;
    width: 26px;
    height: 12px;
    transform: translate(-50%, -50%);
    background: radial-gradient(
        circle at 50% 0%,
        var(--gold) 30%,
        transparent 31%
      ),
      radial-gradient(circle at 30% 100%, var(--gold) 30%, transparent 31%),
      radial-gradient(circle at 70% 100%, var(--gold) 30%, transparent 31%);
    filter: drop-shadow(0 1px 0 rgba(0, 0, 0, 0.12));
  }
`;

export const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  gap: 10px;

  @media (min-width: 720px) {
    gap: 12px;
  }
`;

export const Item = styled.li`
  display: grid;
  grid-template-columns: 28px 1fr;
  align-items: start;
  gap: 10px;

  font-size: clamp(14px, 1.8vw, 16px);
  line-height: 1.5;

  & + & {
    padding-top: 6px;
    border-top: 1px dashed rgba(0, 0, 0, 0.07);
  }
`;

export const Icon = styled.svg`
  width: 22px;
  height: 22px;
  stroke: ${gold};
  fill: none;
  align-self: center;

  @media (min-width: 720px) {
    width: 24px;
    height: 24px;
  }
`;

export const Strong = styled.span`
  font-weight: 800;
`;

export const Note = styled.p`
  margin: 14px 0 6px;
  font-size: 13px;
  line-height: 1.4;
  text-align: center;
  color: ${ink};
  padding: 8px 10px;
  border: 1px dashed ${gold};
  border-radius: 10px;
  background: rgba(196, 164, 83, 0.06);
`;

export const Quote = styled.blockquote`
  margin: 16px 0 4px;
  padding: 14px 16px;
  font-size: clamp(13px, 1.7vw, 15px);
  line-height: 1.6;
  color: ${ink};
  background: #ffffffcc;
  border-left: 3px solid ${gold};
  border-radius: 12px;
  position: relative;

  > span[aria-hidden="true"] {
    position: absolute;
    left: 10px;
    top: -8px;
    font-size: 40px;
    color: ${gold};
    opacity: 0.25;
    line-height: 1;
  }
`;

export const Manager = styled.footer`
  margin-top: 6px;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.7);
  text-align: right;
`;
